<div class="row mb-3">
  <div class="col-12">
    @if (accordionTitle) {
      <h2 class="text-mw">{{ accordionTitle }}</h2>
    }
    <div ngbAccordion #acc="ngbAccordion" class="accordion">
      @for (accordion of accordions; track accordion; let index = $index) {
        <div ngbAccordionItem class="card">
          <h2 ngbAccordionHeader class="card-header no-signature">
            <button ngbAccordionButton [attr.data-e2e]="e2e + '-' + index + '-title'">
              <div class="accordion-card-title">
                <div class="accordion-title">{{ accordion.title }}</div>
                <span class="accordion-icon"></span>
              </div>
            </button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody class="card-body">
              <ng-template>
                <div [attr.data-e2e]="e2e + '-' + index + '-content'">
                  @if (accordion.body) {
                    @for (paragraph of accordion.body; track paragraph) {
                      <p class="standard text-mw" [innerHTML]="paragraph"></p>
                    }
                  }
                  @if (accordion.buttonLabel) {
                    <a
                      [href]="accordion?.href || '#'"
                      [attr.data-e2e]="e2e + '-' + index + '-link'"
                      class="o-link-arrow"
                      (click)="emitButtonClickEvent('accordion', index, accordion?.href);false"
                    >
                      {{ accordion.buttonLabel }}
                    </a>
                  }
                  @if (accordion.bulletList) {
                    <ul class="list" [attr.data-e2e]="e2e + '-' + index + '-list'">
                    @for (item of accordion.bulletList; track item) {
                      <li [innerHTML]="item"></li>
                    }
                    </ul>
                  }
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
